import React, { useState } from "react";
import "./creditprojects.scss";
import DataTable from "../../../components/landing/Creditprojects/DataTable/DataTable";
import AddProject from "./AddProject";
import Loader from "../../../hooks/loader";
import { useCreditProjects } from "../../../hooks/Refund/useCreditProjects";
import useAdminAllowed from "../../../hooks/userManagement/useAdminAllowed";


const Creditprojects = () => {
  const { data, loader, getData, handleToggle } = useCreditProjects();
  const [checkAdmin, isAdmin] = useAdminAllowed();

  if (loader) {

    return <Loader /> 
  }

  return (
    <>
      <section className="creditprojects">
        <div className="custom-container">
          <div className="topheadings">
            <div className="leftheadings">
              <p className="toppara">CREDITS REFUND</p>
              <h4 className="dashboardhead">Buy with Credit Projects</h4>
            </div>
            {isAdmin && <AddProject getData={getData} data={data} />}
          </div>

          {data && data?.length != 0 && <DataTable data={data} handleToggle={handleToggle} getData={getData} isAdmin={isAdmin}/>}
        </div>
      </section>

    </>
  );
};

export default Creditprojects;
